var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.start)?_c('div',{staticClass:"loadding_page"},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ring"},[_c('div',{staticClass:"lds-dual-ring"})])
}]

export { render, staticRenderFns }